import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';

export default function RejectDeleteB2BCustomer(props) {
    const { isOpen, setIsOpen } = props;

    const onCloseDialogReject = (event, reason) => {
        if (event && reason === "backdropClick") {
            return false;
        }
        setIsOpen(false);
    }

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseDialogReject(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {I18n.get('USER12MSG011')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onCloseDialogReject}
                >
                    {I18n.get('COMBTN006')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
